import gql from "graphql-tag";

const DELETE_KUSTOM_CONFIG = gql`
    mutation deleteKlarnaCheckoutConfig($id: ID!) {
        deleteKlarnaCheckoutConfig(id: $id) {
            status
        }
    }
`;

export default DELETE_KUSTOM_CONFIG;
